import React from 'react';
import { useKeyEvents } from '../../lib/hooks';

const ENTER_KEY = 13;

const Model = (props) => {
	const change = (k, v) => {
		if(props.change) props.change(k, v);
	};

	const renderChildren = () => {
		return React.Children.map(props.children, (child) => {
			if(child === "" || child == 0) return null;

			if(child == null) return child; //|| child.type.displayName == undefined

			let data = {
				change,
				model:props.model
			};

			if(props.errors) data.errors = props.errors;

			return React.cloneElement(child, data);
		});
	};

	/*
	// Idea to make the forms have auto-submit on ENTER keypress event
	// only if props.onSubmit is passed to <Model />
	useKeyEvents({
		[ENTER_KEY]:() => {
			props.onSubmit();
		},
	}, 'keyup');*/

	const classname = props?.classname ?? null;
	const style = props?.style ?? null;

	const use_wrapper = props?.use_wrapper ?? true;

	if(!use_wrapper) {
		return (
			<>
				{renderChildren()}
			</>
		)
	}

	return (
		<div class={classname} style={style}>
			{renderChildren()}
		</div>
	)
}

export default Model;